import { Icon } from '@yes.technology/react-toolkit'

import { useTranslation } from 'react-i18n-lite'
import formatDate from 'shared/utils/date'
import { AllowedLocales } from 'shared/utils/date/formatDate'

import {
  DataOrigin,
  FilterDate,
  StyledAppliedFilters
} from './AppliedFilters.styles'

export type AppliedFilterFieldValuesProps = {
  operator: string
  value: string
  label: string
}

export type AppliedFiltersProps = {
  referencePeriodStartISO?: string
  referencePeriodEndISO?: string
  referenceDateISO?: string
  fieldValues?: AppliedFilterFieldValuesProps[]
}

const StaticFilterApplied = ({
  referenceDateISO,
  referencePeriodEndISO,
  referencePeriodStartISO
}: AppliedFiltersProps) => {
  const { t } = useTranslation()
  const { language } = useTranslation()
  const currentYear = new Date().getFullYear()
  const firstDayOfYear = new Date(currentYear, 0, 1).toISOString()
  const lastDayOfYear = new Date(currentYear, 11, 31).toISOString()
  const today = new Date().toISOString()
  const formatLanguage = language as AllowedLocales
  return (
    <FilterDate>
      <div>
        <Icon iconName='FiltersFill' icSize='extraSmall' />
        {t('cockpit.filter.reference-period')} ≥{' '}
        {formatDate(referencePeriodStartISO || firstDayOfYear, formatLanguage, {
          dateStyle: 'short'
        })}
      </div>
      <div>
        {t('cockpit.filter.reference-period')} ≤{' '}
        {formatDate(referencePeriodEndISO || lastDayOfYear, formatLanguage, {
          dateStyle: 'short'
        })}
      </div>
      <div>
        {t('cockpit.filter.reference-date')} ={' '}
        {formatDate(referenceDateISO || today, formatLanguage, {
          dateStyle: 'short'
        })}
      </div>
    </FilterDate>
  )
}

const AppliedFilters = ({
  referenceDateISO,
  referencePeriodEndISO,
  referencePeriodStartISO,
  fieldValues
}: AppliedFiltersProps) => {
  const { t } = useTranslation()
  return (
    <StyledAppliedFilters>
      <DataOrigin>
        <h1>{t('cockpit.filter.data-origin-title')}</h1>

        {!fieldValues?.length && (
          <StaticFilterApplied
            referenceDateISO={referenceDateISO}
            referencePeriodEndISO={referencePeriodEndISO}
            referencePeriodStartISO={referencePeriodStartISO}
          />
        )}

        {fieldValues && fieldValues?.length > 0 && (
          <FilterDate>
            {fieldValues.map((filter, i) => (
              <div key={`${i}-${filter.label}`}>
                {i === 0 && <Icon iconName='FiltersFill' icSize='extraSmall' />}
                {filter.label} {filter.operator} {filter.value}
              </div>
            ))}
          </FilterDate>
        )}
      </DataOrigin>
    </StyledAppliedFilters>
  )
}

export default AppliedFilters
